const Service = (type, action) => {
	let parsed = null;

	switch (type) {
		case "PERMISSION.SET": {
			parsed = {
				type: "POST",
				url: "/ajax/set-permission/",
				payload: action.payload,
			};
			break;
		}

		case "TAKEOVER": {
			parsed = {
				type: "POST",
				url: "/ajax/possess-employee/",
				payload: action.payload,
			};
			break;
		}

		case "INVITATION.SEND": {
			parsed = {
				type: "POST",
				url: "/ajax/invite-employee/",
				payload: action.payload,
			};
			break;
		}

		default: {
			break;
		}
	}

	return parsed;
};

export default Service;
